import { observer } from "mobx-react";
import { Box, Stack } from "@mui/material";
import ContentBlock from "../components/ContentBlock";
import VaccinationEntryForm from "../components/forms/vaccination/VaccinationEntryForm";
import VaccinationDayList from "../components/lists/VaccinationDayList";
import InfoText from "../components/typographies/InfoText";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Measurement } from "../models/Measurements";
import dayjs from "dayjs";

const Vaccination = observer(() => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState<any | undefined>(undefined);

  const handleSelectDay = (day: Measurement) => {
    const initialData = {
      ...day,
      date: dayjs(day.date).format("YYYY-MM-DD"),
    };
    setSelectedDay(initialData);
  };

  return (
    <Box className="page-container">
      <Box sx={{ marginBottom: 2 }}>
        <Stack spacing={2}>
          <InfoText text={t("vaccinations.info1")} />
          <InfoText text={t("vaccinations.info2")} />
        </Stack>
      </Box>
      <ContentBlock title="Registrera: Vaccination" icon="edit" bottomMargin>
        <VaccinationEntryForm
          selectedDay={selectedDay}
          onDeSelect={() => setSelectedDay(undefined)}
        />
      </ContentBlock>
      <ContentBlock title="Vaccination" icon="list">
        <VaccinationDayList onClick={handleSelectDay} />
      </ContentBlock>
    </Box>
  );
});

export default Vaccination;
